import { CONNECTS_API_SLUG, NEXUS_API_SLUG } from 'src/constants'

import { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'

const ApiDocLinksV1: FunctionComponent = () => {
  return (
    <>
      <NavLink to={`/${CONNECTS_API_SLUG}`} data-testid="connects-docs-link">
        Connects API
      </NavLink>

      <NavLink to={`/${NEXUS_API_SLUG}`} data-testid="nexus-docs-link">
        Nexus API
      </NavLink>
    </>
  )
}

export default ApiDocLinksV1
